/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileIllustrator16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M12.42 5.805c.072 0 .108.027.108.107v6.982c0 .07-.018.106-.107.106h-1.393c-.09 0-.117-.044-.117-.115V5.912h-.009c0-.071.027-.107.108-.107h1.41zM6.608 3.248c.063 0 .09.017.108.088l2.857 9.549c.018.07 0 .115-.072.115H8.01c-.072 0-.117-.018-.135-.08l-.737-2.663H4.262l-.71 2.655c-.018.07-.045.088-.135.088h-1.32c-.09 0-.109-.027-.09-.133l2.551-8.796c.045-.16.072-.301.09-.735 0-.062.027-.088.072-.088h1.887zM5.69 4.664h-.018C5.484 5.699 5.007 7.45 4.63 8.823h2.13c-.252-.982-.845-3.124-1.07-4.16zM11.72 3c.548 0 .916.363.916.903 0 .584-.386.902-.934.902-.521 0-.899-.318-.899-.902 0-.567.404-.903.917-.903z"
        />
    </AccessibleSVG>
);

export default FileIllustrator16;
